import { handleError } from './utils';

export const getUserProfile = () => handleError(async (dispatch, getState, { api }) => {
  const [details, transactions] = await Promise.all([
    await api.getProfile(),
    await api.getTransactions(),
  ])

  return {...transactions, ...details };
}, 'There was en error getting profile details.');

export const getUserTransactions = () => handleError(async (dispatch, getState, { api }) => {
  const objects = await api.getTransactions();

  return objects;
}, 'There was en error getting transaction details.');